import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIp, setCoordinates, setLocationFlag } from '../Store/userSlice';
import { useLocation } from 'react-router-dom';

const LocationTracker = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const locFlag = useSelector((state) => state.user.locationFlag);
  const existingIp = useSelector(state => state.user.ip);
  const existingCoords = useSelector(state => state.user.coordinates);
  
  // Use refs to track API calls in current session
  const ipFetchedRef = useRef(false);
  const geoFetchedRef = useRef(false);

  // Fetch IP address only if not already in Redux store
  useEffect(() => {
    // Check if we already have IP in Redux or if we've already fetched in this session
    if ((!existingIp || existingIp === '') && !ipFetchedRef.current) {
      // Set ref to avoid duplicate calls within same mount
      ipFetchedRef.current = true;
      
      // Check session storage to avoid duplicate calls across re-mounts
      const lastIpCheck = sessionStorage.getItem('ipLastChecked');
      const currentTime = Date.now();
      
      // Only fetch if we haven't checked in the last 5 minutes
      if (!lastIpCheck || (currentTime - parseInt(lastIpCheck)) > 300000) {
        sessionStorage.setItem('ipLastChecked', currentTime.toString());
        
        fetch("https://api.ipify.org?format=json")
          .then((response) => response.json())
          .then((data) => {
            dispatch(setIp(data?.ip));
          })
          .catch((error) => console.error("Error fetching IP:", error));
      }
    }
  }, [dispatch, existingIp]);

  // Get geolocation coordinates
  useEffect(() => {
    // Check if we already have coordinates in Redux or if we've already fetched
    const hasCoords = existingCoords && (existingCoords.lat || existingCoords.lng);
    
    if (!hasCoords && !geoFetchedRef.current) {
      // Set ref to avoid duplicate calls within same mount
      geoFetchedRef.current = true;
      
      // Check session storage to avoid duplicate calls across re-mounts
      const lastGeoCheck = sessionStorage.getItem('geoLastChecked');
      const currentTime = Date.now();
      
      // Only get location if we haven't checked in the last 5 minutes
      if (!lastGeoCheck || (currentTime - parseInt(lastGeoCheck)) > 300000) {
        sessionStorage.setItem('geoLastChecked', currentTime.toString());        
        const searchParams = new URLSearchParams(location.search);
        let qlat = searchParams.get("latitude");
        let qlng = searchParams.get("longitude");
        let pathname = {
          coords: {
            latitude: qlat ? Number(qlat) : null,
            longitude: qlng ? Number(qlng) : null,
          },
        };

        if (pathname.coords.latitude && pathname.coords.longitude && locFlag === true) {
          success(pathname);
          dispatch(setLocationFlag(false));
        } else {
          navigator.geolocation.getCurrentPosition(success, error);
        }
        dispatch(setLocationFlag(false));
      }
    }
  }, [dispatch, locFlag, location.search, existingCoords]);

  const error = (err) => {
    dispatch(setLocationFlag(false));
  };

  const success = (position) => {
    const coordinates = {
      lat: position.coords.latitude ? position.coords.latitude : "",
      lng: position.coords.longitude ? position.coords.longitude : "",
    };
    dispatch(setCoordinates(coordinates));
  };

  return null;
};

export default LocationTracker; 